/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_GleichesgeschlechtInputs */

const en__field_enum_gleichesgeschlecht = /** @type {(inputs: _Field_Enum_GleichesgeschlechtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`same gender`)
};

const de__field_enum_gleichesgeschlecht = /** @type {(inputs: _Field_Enum_GleichesgeschlechtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gleiches Geschlecht`)
};

/**
* | output |
* | --- |
* | "same gender" |
*
* @param {_Field_Enum_GleichesgeschlechtInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_enum_gleichesgeschlecht = /** @type {((inputs?: _Field_Enum_GleichesgeschlechtInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_GleichesgeschlechtInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_gleichesgeschlecht(inputs)
	return de__field_enum_gleichesgeschlecht(inputs)
});